// src/components/Profile/MyReviewsSection.js
// Section mes avis (connecté à l'API)

import React, { useState, useEffect } from 'react';
import { Star, MapPin, Calendar } from 'lucide-react';
import reviewService from '../../services/reviewService';
import './MyReviewsSection.css';

const MyReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Charger les avis au montage
  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = async () => {
    setLoading(true);
    const result = await reviewService.getMyReviews();
    if (result.success) {
      setReviews(result.reviews);
    }
    setLoading(false);
  };

  // Formater la date
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('fr-FR', options);
  };

  // Afficher les étoiles
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={18}
        fill={index < rating ? '#FCD34D' : 'none'}
        stroke={index < rating ? '#FCD34D' : '#D1D5DB'}
        strokeWidth={2}
      />
    ));
  };

  if (loading) {
    return (
      <div className="reviews-section">
        <h2>Mes avis</h2>
        <div className="loading-reviews">
          <div className="spinner"></div>
          <p>Chargement de vos avis...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="reviews-section">
      <h2>Mes avis</h2>
      <p className="section-subtitle">
        Retrouvez tous les avis que vous avez laissés ({reviews.length})
      </p>

      {reviews.length === 0 ? (
        <div className="empty-reviews">
          <Star size={64} color="#D1D5DB" />
          <h3>Aucun avis pour le moment</h3>
          <p>Partagez votre expérience après vos rendez-vous terminés</p>
        </div>
      ) : (
        <div className="reviews-list">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              
              {/* Header */}
              <div className="review-header">
                <div className="review-info">
                  <h3>{review.salon_name}</h3>
                  <div className="review-meta">
                    <span className="date">
                      <Calendar size={14} />
                      {formatDate(review.created_at)}
                    </span>
                  </div>
                </div>
                <div className="rating">
                  {renderStars(review.rating)}
                </div>
              </div>

              {/* Comment */}
              {review.comment && (
                <p className="review-comment">{review.comment}</p>
              )}

              {/* Réponse du salon */}
              {review.response_text && (
                <div className="salon-response">
                  <div className="response-header">
                    <span className="response-icon">💬</span>
                    <strong>Réponse du salon</strong>
                    <span className="response-date">
                      {formatDate(review.response_date)}
                    </span>
                  </div>
                  <p className="response-text">{review.response_text}</p>
                </div>
              )}

            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyReviewsSection;